
import React from "react";
import founderImg from "../../assets/Founder.webp";
// import founderImg from "../../assets/Profile.png";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";

const MeetFounder = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full">

      {/* TOP SECTION */}
      <div className="pt-16 pb-32 text-center relative">
        <h2 className="text-3xl md:text-4xl font-serif text-[#1F2937]">
          Meet Our Founder
        </h2>
      </div>

      {/* BOTTOM SECTION */}
      <div className="bg-white pb-16 px-4 relative">

        {/* IMAGE + BADGE */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-20 text-center">

          <div className="relative inline-block">

            {/* IMAGE */}
            <img
              src={founderImg}
              alt="Founder"
              className="w-40 h-40 rounded-full object-cover shadow-xl border-4 border-white"
            />

            {/* BADGE */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.05)] px-6 py-1 rounded-full text-[10px] text-black">
              Founding <br /> Director
            </div>

          </div>
        </div>

        {/* CONTENT */}
        <div className="pt-28 text-center max-w-5xl mx-auto">

          {/* NAME */}
          <h3 className="text-lg font-semibold text-[#1F2937]">
            Rajkumar
          </h3>

          {/* LOCATION */}
          <p className="text-xs text-[#6A8E22] mb-6">
            Idukki, Kerala
          </p>

          {/* QUOTE */}
          <p className="text-xl md:text-3xl font-times text-[#2F2F2F] mb-4 leading-relaxed">
            "Land is not just an asset, it is a legacy we pass down"
          </p>

          {/* DIVIDER */}
          <div className="w-16 h-[2px] bg-[#45A30166] mx-auto mb-8 mt-8"></div>

          {/* DESCRIPTION */}
          <p className="text-[#2F2F2FCC] text-sm leading-relaxed mb-6">
            With over three decades of mastery in the highland real estate landscape,
            we specialize in curating estates that respect the ecological soul of Kerala.
            Our commitment to integrity ensures that every transaction is a step toward
            preserving the majesty of Idukki for generations to come.
          </p>

          <div className="flex justify-center">

            <button
              onClick={() => navigate("/portfolio")}
              className="mt-12 bg-[#45A301] hover:bg-[#3e9202] text-white px-10 py-2.5 rounded-lg flex items-center gap-2 transition shadow-md"
            >
              View Portfolio
              <FaArrowRightLong />
            </button>
              </div>
          </div>

      </div>

    </section>
  );
};

export default MeetFounder;